import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'
import React from 'react'
import LogRocket from 'logrocket'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import ReactDOM from 'react-dom'
import App from './App'
import './App.css'
import 'ui/lib/mcss-ui.scss'
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer'
import * as serviceWorker from './serviceWorker'
import ReactGA from 'react-ga'

const privateFieldNames = [
  'ssn',
  'firstName',
  'birthDate',
  'password',
  'Authorization',
]

const { requestSanitizer, responseSanitizer } =
  LogrocketFuzzySanitizer.setup(privateFieldNames)

LogRocket.init('rngp6b/mcss-educator-pro-connect', {
  release: process.env.REACT_APP_ENVIRONMENT || 'local',
  network: {
    requestSanitizer: requestSanitizer as any,
    responseSanitizer: responseSanitizer as any,
  },
})

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS ?? '')
Sentry.init({
  dsn: 'https://c2dbced6f8e845a2b4c870e63110a673@sentry.io/1872067',
  environment: process.env.REACT_APP_ENVIRONMENT || 'local',
  integrations: [new Integrations.BrowserTracing()],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
})

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
